import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../api/index.js";
import { useDispatch } from "react-redux";
import { setloggedIn } from "../../store/Slices/userSlice.js";
import { clearCookies } from "../../services/Cookies.jsx";

let errorToastId = null;

const showErrorToast = (message) => {
  if (errorToastId) return;

  errorToastId = toast.error(message, {
    onClose: () => {
      errorToastId = null;
    },
  });
};

const SessionManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        dispatch(setloggedIn(false));
        clearCookies();
        showErrorToast(
          "Your session has expired. Please login to pick up where you left off."
        );
        return navigate("/login");
      }
      return Promise.reject(error);
    }
  );
};

export default SessionManager;
